module.exports = __webpack_public_path__ + "media/packs/images/flags/IS-e55baf489e0b9de23400e56d8499d0ab.svg";